<div
  class="flex flex-col rounded-(--detailexpandablecard-border-radius) gap-(--detailexpandablecard-gap) px-(--detailexpandablecard-padding-x) py-(--detailexpandablecard-padding-y) w-full"
  [style.background]="containerBackground()"
>
  <app-dynamic
    componentName="DynamicText"
    [props]="titleProps()"
  />

  @if (isExpanded()) {
    <div
      class="text-(--detailexpandablecard-content-color)"
      [innerHTML]="sanitizedContent()"
    ></div>
  }

  <div class="self-start">
    <app-dynamic
      componentName="Button"
      [props]="buttonProps()"
      (action)="toggle()"
    />
  </div>
</div>
